import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  personalInfo: {},
};

export const personalInfoSlice = createSlice({
  name: "personalInfo",
  initialState,
  reducers: {
    setPersonalInfo: (state, action) => {
      state.personalInfo = {
        ...state.personalInfo,
        ...action.payload.personalInfo,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setPersonalInfo } = personalInfoSlice.actions;
export const getPersonalInfo = (state) => {
  return state.personalInfo.personalInfo;
};

export default personalInfoSlice.reducer;
